import { Component, OnInit } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    constructor(
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private router: Router
    ) {
        // const firestore = firebase.firestore();
        // const settings = {/* your settings... */ timestampsInSnapshots: true };
        // firestore.settings(settings);
        localStorage.removeItem('firebase:previous_websocket_failure');
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/app.component.ts